/* eslint-disable @typescript-eslint/naming-convention */
import alpha from '@/services/validation/defaultValidators/alpha'
import alpha_dash from '@/services/validation/defaultValidators/alpha_dash'
import alpha_num from '@/services/validation/defaultValidators/alpha_num'
import alpha_spaces from '@/services/validation/defaultValidators/alpha_spaces'
import between from '@/services/validation/defaultValidators/between'
import confirmed from '@/services/validation/defaultValidators/confirmed'
import digits from '@/services/validation/defaultValidators/digits'
import dimensions from '@/services/validation/defaultValidators/dimensions'
import email from '@/services/validation/defaultValidators/email'
import ext from '@/services/validation/defaultValidators/ext'
import image from '@/services/validation/defaultValidators/image'
import integer from '@/services/validation/defaultValidators/integer'
import ip from '@/services/validation/defaultValidators/ip'
import is from '@/services/validation/defaultValidators/is'
import is_not from '@/services/validation/defaultValidators/is_not'
import length from '@/services/validation/defaultValidators/length'
import max from '@/services/validation/defaultValidators/max'
import max_value from '@/services/validation/defaultValidators/max_value'
import mimes from '@/services/validation/defaultValidators/mimes'
import min from '@/services/validation/defaultValidators/min'
import min_value from '@/services/validation/defaultValidators/min_value'
import not_one_of from '@/services/validation/defaultValidators/not_one_of'
import numeric from '@/services/validation/defaultValidators/numeric'
import one_of from '@/services/validation/defaultValidators/one_of'
import regex from '@/services/validation/defaultValidators/regex'
import required from '@/services/validation/defaultValidators/required'
import size from '@/services/validation/defaultValidators/size'
import url from '@/services/validation/defaultValidators/url'
import urlRegex from '@/services/validation/defaultValidators/url_regex'
import type { ValidationRuleFunction } from '@/services/validation/types'

export {
  alpha_dash,
  alpha_num,
  alpha_spaces,
  alpha,
  between,
  confirmed,
  digits,
  dimensions,
  email,
  ext,
  image,
  integer,
  ip,
  is_not,
  is,
  length,
  max_value,
  max,
  mimes,
  min_value,
  min,
  not_one_of,
  numeric,
  one_of,
  regex,
  required,
  size,
  url,
  urlRegex,
}

const defaultRules: Record<string, ValidationRuleFunction> = {
  alpha_dash,
  alpha_num,
  alpha_spaces,
  alpha,
  between,
  confirmed,
  digits,
  dimensions,
  ext,
  image,
  integer,
  ip,
  is_not,
  is,
  length,
  max_value,
  max,
  mimes,
  min_value,
  min,
  not_one_of,
  numeric,
  one_of,
  regex,
  required,
  size,
  url,
  urlRegex,
}

export default defaultRules
